const ITEMS = [
  "Soya · Santa Cruz de la Sierra",
  "Sorgo y maíz · Cuatro Cañadas",
  "Caña de azúcar · Pailón",
  "Desecación y maduración · San Julián",
  "Siembra y fertilización · Okinawa",
  "Cobertura total · Montero y Mineros",
  "Aplicación de precisión · Chiquitania",
];

const Marquee = () => {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div
      data-testid="marquee-strip"
      className="bg-[#151A1F] border-y border-[#00A651]/25 py-4 overflow-hidden"
      aria-hidden="true"
    >
      <div className="marquee-track">
        {row.map((item, i) => (
          <span
            key={i}
            className="font-mono-tech text-xs uppercase tracking-[0.3em] text-[#F6F7F5]/75 whitespace-nowrap px-8 flex items-center gap-8"
          >
            {item}
            <span className="text-[#00A651]">/</span>
          </span>
        ))}
      </div>
    </div>
  );
};

export default Marquee;
